// extracted by mini-css-extract-plugin
export default {"section":"simulator_section__i5H8W"};